import {createStore} from "vuex";

import auth from "@/store/modules/auth";
import tags from './modules/tags';
import files from './modules/files';
import shortLinks from './modules/shortLinks';

export default createStore({
    modules: {
        auth,
        tags,
        files,
        shortLinks,
    }
});
